// extracted by mini-css-extract-plugin
module.exports = {"target":"EmployeeAttendanceDownloadCsvPage__target--1Z642","period":"EmployeeAttendanceDownloadCsvPage__period--FZSPO","detail":"EmployeeAttendanceDownloadCsvPage__detail--2XPN0"};